<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      unit="教职员工信息"
      edit-title
      id-key="TeacherId"
      :data="data"
      form-label-width="110px"
      :get-data-func="getInfoFunc"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      :save-func="()=>{}"
      @closed="onClosed"
    >
      <template slot="form">
        <template v-if="base">
          <div class="row-head">基本信息</div>
          <el-row class="border" v-if="base">
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="教职工编号" prop="TeacherNumber">
                  <el-input v-model="data.TeacherNumber" :disabled="!all" placeholder="请填写教职工编号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="姓名" prop="TeacherName">
                  <el-input v-model="data.TeacherName" placeholder="请填写姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="性别" prop="Sex">
                  <el-select v-model="data.Sex" placeholder="请选择">
                    <el-option label="无" :value="0"></el-option>
                    <el-option label="男" :value="1"></el-option>
                    <el-option label="女" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="验证码" prop="VerificationCode">
                  <el-input v-model="data.VerificationCode" type="number" placeholder="请填写4位验证码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="手机号码" prop="PhoneNumber">
                  <el-input v-model="data.PhoneNumber" type="number" placeholder="请填写手机号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="短号" prop="ShortNo">
                  <el-input v-model="data.ShortNo" placeholder="请填写短号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="状态" prop="Status">
                  <el-select v-model="data.Status" placeholder="请选择" :disabled="!all">
                    <el-option label="教师在岗" :value="0"></el-option>
                    <el-option label="教辅在岗" :value="2"></el-option>
                    <el-option label="其他" :value="3"></el-option>
                    <el-option label="离退" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="现任职务">
                  <span>{{data.JobNames}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="任职开始时间" prop="InDate">
                  <span>{{data.JobStartDates}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="公众号OpenId">
                  <el-input v-model="data.WxPublicId" disabled placeholder="请填写OpenId">
                    <el-button slot="append" :disabled="!all" @click.stop="clearOpenId">清空</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <!-- <el-row class="border" v-else>
            <span class="no-per">无权限</span>
          </el-row>-->
        </template>
        <template v-if="edu">
          <div class="row-head">学历资历</div>
          <el-row class="border" v-if="edu">
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="最高学历" prop="Edu">
                  <el-select v-model="data.Edu" placeholder="请选择">
                    <template v-for="(i,key) in EduList">
                      <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="学历类型" prop="EduType">
                  <el-select v-model="data.EduType" placeholder="请选择">
                    <el-option label="全日制" value="全日制"></el-option>
                    <el-option label="在职" value="在职"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="参加工作时间" prop="WordDate">
                  <el-date-picker
                    v-model="data.WordDate"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="入职时间" prop="InDate">
                  <el-date-picker
                    v-model="data.InDate"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="政治面貌" prop="Politics">
                  <el-select v-model="Politics" multiple placeholder="请选择">
                    <el-option label="党员" value="党员"></el-option>
                    <el-option label="非党员" value="非党员"></el-option>
                    <el-option label="民盟" value="民盟"></el-option>
                    <el-option label="民进" value="民进"></el-option>
                    <el-option label="农工" value="农工"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="入党时间" prop="JoinDate">
                  <el-date-picker
                    v-model="data.JoinDate"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="职称" prop="Title">
                  <el-select v-model="data.Title" :disabled="!title" placeholder="请选择">
                    <el-option label="未定级" value="未定级"></el-option>
                    <el-option label="二级" value="二级"></el-option>
                    <el-option label="一级" value="一级"></el-option>
                    <el-option label="高级" value="高级"></el-option>
                    <el-option label="正高级" value="正高级"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="评定时间" prop="EvaluateDate">
                  <el-date-picker
                    :disabled="!title"
                    v-model="data.EvaluateDate"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input v-model="data.Remark" placeholder="请填写备注"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="是否完成支教" prop="HasSupport">
                  <el-radio-group v-model="data.HasSupport" :disabled="!title">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <!-- <el-row class="border" v-else>
            <span class="no-per">无权限</span>
          </el-row>-->
        </template>
        <template v-if="per">
          <div class="row-head">个人信息</div>
          <el-row class="border" v-if="per">
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="身份证号" prop="IdCard">
                  <el-input v-model="data.IdCard" placeholder="请填写身份证号" @blur="onIdCardBlur"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="出生年月" prop="BirthDate">
                  <el-input v-model="data.BirthDate" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="年龄" prop="Age">
                  <el-input v-model="data.Age" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="籍贯" prop="NativePlace">
                  <el-input v-model="data.NativePlace" placeholder="请填写籍贯"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="户籍" prop="Register">
                  <el-input v-model="data.Register" placeholder="请填写户籍"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="家庭地址" prop="Address">
                  <el-input v-model="data.Address" placeholder="请填写家庭地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="宿舍楼" prop="Dormitory">
                  <el-select v-model="data.Dormitory" placeholder="请选择">
                    <template v-for="(i,key) in DormitoryList">
                      <el-option :key="key" :label="i.DataName" :value="i.DataName"></el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="宿舍房号" prop="DormitoryNo">
                  <el-input v-model="data.DormitoryNo" placeholder="请填写宿舍房号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="进校车牌" prop="InCarNo">
                  <el-input v-model="data.InCarNo" placeholder="请填写进校车牌"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="紧急联系人" prop="ContactPerson">
                  <el-input v-model="data.ContactPerson" placeholder="请填写紧急联系人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="紧急联系电话" prop="ContactPhone">
                  <el-input v-model="data.ContactPhone" placeholder="请填写紧急联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <!-- <el-row class="border" v-else>
            <span class="no-per">无权限</span>
          </el-row>-->
        </template>
        <template>
          <div class="row-tb-head">
            <span>年度考核情况</span>
            <div style="float: right;" v-if="check">
              <el-button type="primary" icon="el-icon-plus" @click="addCheck">添加</el-button>
            </div>
          </div>
          <el-table class="tb-c-head" :data="data.Checks" border v-if="check">
            <el-table-column label="年度" prop="CheckYear" width="150px">
              <template slot-scope="{row}">
                <el-date-picker
                  type="year"
                  v-model="row.CheckYear"
                  value-format="yyyy"
                  placeholder="选择年份"
                  @change="setT(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="考核结果" prop="CheckResult">
              <template slot-scope="{row}">
                <el-select v-model="row.CheckResult" @change="setT(row)" placeholder="选择考核结果">
                  <el-option label="优秀" value="优秀"></el-option>
                  <el-option label="合格" value="合格"></el-option>
                  <el-option label="不合格" value="不合格"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="60px">
              <template slot-scope="{row,$index}">
                <el-button type="text" @click="delCheck(row,$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table class="tb-c-head" :data="data.Checks" border v-else>
            <el-table-column label="年度" prop="CheckYear" width="150px" />
            <el-table-column label="考核结果" prop="CheckResult" />
          </el-table>
          <!-- <el-row class="border" v-else>
          <span class="no-per">无权限</span>
          </el-row>-->
        </template>
        <template>
          <div class="row-tb-head">
            <span>职务变动情况</span>
            <div style="float: right;" v-if="job">
              <el-button type="primary" icon="el-icon-plus" @click="addJob">添加</el-button>
            </div>
          </div>
          <el-table class="tb-c-head" :data="data.Jobs" border v-if="job">
            <el-table-column label="职务名称" prop="JobName">
              <template slot-scope="{row}">
                <el-select v-model="row.JobId" @change="setT(row)" placeholder="选择职务">
                  <template v-for="(i,key) in jobList">
                    <el-option :key="key" :label="i.JobName" :value="i.JobId"></el-option>
                  </template>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="开始时间" prop="StartDate">
              <template slot-scope="{row}">
                <el-date-picker
                  v-model="row.StartDate"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="setDate(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="截止时间" prop="EndDate">
              <template slot-scope="{row}">
                <el-date-picker
                  v-model="row.EndDate"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="setDate(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="60px">
              <template slot-scope="{row,$index}">
                <el-button type="text" @click="delJob(row,$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table class="tb-c-head" :data="data.Jobs" border v-else>
            <el-table-column label="职务名称" prop="JobName" />
            <el-table-column label="开始时间" prop="StartDate">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.StartDate)}}</template>
            </el-table-column>
            <el-table-column label="截止时间" prop="EndDate">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.EndDate)}}</template>
            </el-table-column>
          </el-table>
          <!-- <el-row class="border" v-else>
          <span class="no-per">无权限</span>
          </el-row>-->
        </template>
        <div class="row-tb-head">
          <span>部门列表</span>
          <div style="float: right;" v-if="all">
            <el-button type="primary" icon="el-icon-plus" @click="addDp">添加</el-button>
          </div>
        </div>
        <el-table class="tb-c-head" :data="data.Dps" border v-if="all">
          <el-table-column label="部门名称" prop="DpName">
            <template slot-scope="{row}">
              <tree-select
                parent-select
                :props="dpProps"
                :options="dpTree"
                :value="row.DpId"
                :clearable="false"
                @node-select="dpSelect($event,row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="主要部门" prop="IsMain">
            <template slot-scope="{row}">
              <el-checkbox v-model="row.IsMain" @change="dpChange(row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="部门负责人" prop="IsDirector">
            <template slot-scope="{row}">
              <el-checkbox v-model="row.IsDirector"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="delDp(row,$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="tb-c-head" :data="data.Dps" border v-else>
          <el-table-column label="部门名称" prop="DpName" />
          <el-table-column label="主要部门" prop="IsMain">
            <template slot-scope="{row}">{{row.IsMain?"是":"否"}}</template>
          </el-table-column>
          <el-table-column label="部门负责人" prop="IsDirector">
            <template slot-scope="{row}">{{row.IsDirector?"是":"否"}}</template>
          </el-table-column>
        </el-table>
        <div class="row-tb-head">
          <span>标签列表</span>
          <div style="float: right;" v-if="all">
            <el-button type="primary" icon="el-icon-plus" @click="addTag">添加</el-button>
          </div>
        </div>
        <el-table class="tb-c-head" :data="data.Tags" border v-if="all">
          <el-table-column label="标签名称" prop="TagName">
            <template slot-scope="{row}">
              <el-select v-model="row.TagId" @change="setT(row)" placeholder="选择标签">
                <template v-for="(i,key) in TagList">
                  <el-option :key="key" :label="i.TagName" :value="i.TagId"></el-option>
                </template>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="60px">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="delTag(row,$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table class="tb-c-head" :data="data.Tags" border v-else>
          <el-table-column label="标签名称" prop="TagName" />
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <el-button type="primary" :loading="isLoading" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    treeSelect,
  },
  data() {
    return {
      api: require("@/api/fa/teacher").default,
      jobApi: require("@/api/ent/job").default,
      bd_api: require("@/api/gd/basedata").default,
      dp_api: require("@/api/ent/dp").default,
      tag_api: require("@/api/ent/tag").default,
      isMB: this.$store.state.isMB,
      jobList: [],
      EduList: [],
      DormitoryList: [],
      TagList: [],
      data: {
        TeacherId: 0,
        TeacherNumber: "", //教师编号
        TeacherName: "", //姓名
        VerificationCode: "", //验证码
        PhoneNumber: "", //手机号码
        GradeId: null,
        PushMsg: false, //接收消息
        AttendanceMsg: false, //异常考勤
        MedicalMsg: false, //医疗
        UnRollcallMsg: false, //未点名
        WxPublicId: "", //公众号OpenId
        IdCard: "", //身份证
        Sex: 0, //性别 - 无/男/女
        ShortNo: "", //短号
        Status: 0, //状态 - 教师在岗/离退/教辅在岗/其他
        Edu: "", //最高学历
        EduType: "", //最高学历类型 - 全日制/在职
        WordDate: null, //参加工作时间
        InDate: null, //入职时间
        Politics: "", //政治面貌
        JobNames: "", //现任职务
        JobStartDates: "", //任职开始时间
        JoinDate: null, //入党时间
        Title: "", //职称
        EvaluateDate: null, //评定时间
        Remark: "", //备注
        HasSupport: false, //是否完成支教
        BirthDate: null, //出生年月
        Age: 0, //年龄 - 动态计算
        NativePlace: "", //籍贯
        Register: "", //户籍
        Address: "", //家庭地址
        Dormitory: "", //宿舍楼
        DormitoryNo: "", //宿舍房号
        InCarNo: "", //进校车牌
        ContactPerson: "", //紧急联系人
        ContactPhone: "", //紧急联系电话
        Jobs: [],
        Checks: [],
        Dps: [],
        Tags: [],
      },
      DelJobs: [],
      DelChecks: [],
      DelDps: [],
      DelTags: [],
      FuncCodes: "",
      dpTree: [],
      dpProps: {
        // 配置项（必选）
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      rules: {
        TeacherNumber: [{ required: true, message: "请填写教师编号" }],
        TeacherName: [{ required: true, message: "请填写姓名" }],
        VerificationCode: [{ required: true, message: "请填写4位验证码" }],
        ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone }],
        PhoneNumber: [
          { required: true, message: "请填写手机号码" },
          { validator: this.$commonJs.validateRules.validPhone },
        ],
      },
    };
  },
  computed: {
    base() {
      return this.FuncCodes.indexOf("Base") != -1 || false; //基本信息
    },
    edu() {
      return this.FuncCodes.indexOf("Edu") != -1 || false; //学历资历
    },
    per() {
      return this.FuncCodes.indexOf("Per") != -1 || false; //个人信息
    },
    check() {
      return this.FuncCodes.indexOf("Check") != -1 || false; //年度考核情况
    },
    job() {
      return this.FuncCodes.indexOf("Job") != -1 || false; //职务变动情况
    },
    title() {
      return this.FuncCodes.indexOf("Title") != -1 || false; //职称支教
    },
    all() {
      return this.FuncCodes.indexOf("All") != -1 || false; //全部数据
    },
    Politics: {
      get() {
        if (this.data.Politics) return this.data.Politics.split(",");
        else return [];
      },
      set(val) {
        this.data.Politics = val.join(",");
      },
    },
  },
  mounted() {
    var permission = this.$store.state.sys.permissionMenus;
    var menus = permission.find((x) => x.FullPath == "/fa/teacher");
    this.FuncCodes = menus.FuncCodes;
    console.log("func", this.FuncCodes);
  },
  methods: {
    onCreateOpened() {
      this.getOption();
    },
    getInfoFunc(data) {
      return new Promise((resolve, reject) => {
        this.api.info(data).then((res) => {
          res.Data.Jobs.forEach((x) => (x.T = null));
          res.Data.Checks.forEach((x) => {
            x.CheckYear = x.CheckYear + "";
            x.T = null;
          });
          res.Data.Dps.forEach((x) => (x.T = null));
          res.Data.Tags.forEach((x) => (x.T = null));

          if (res.Data.BirthDate) {
            var data = res.Data.BirthDate;
            res.Data.BirthDate = this.$commonJs.toDateString(data);
            // var Age = new Date().getFullYear() - res.Data.BirthDate;
            res.Data = { ...res.Data };
          }
          this.getOption();
          resolve(res);
        });
      });
    },
    getOption() {
      this.jobApi.list({}).then((res) => {
        this.jobList = res.Data;
      });
      this.bd_api.list({ ClassName: "最高学历" }).then((res) => {
        this.EduList = res.Data;
      });
      this.bd_api.list({ ClassName: "宿舍楼" }).then((res) => {
        this.DormitoryList = res.Data;
      });
      this.dp_api.list({}).then((res) => {
        this.dpTree = this.$commonJs.toTreeData(res.Data, "DpId");
      });
      this.tag_api.list({}).then((res) => {
        this.TagList = res.Data;
      });
    },
    setT(row) {
      row.T = row.T == 0 ? 0 : 1;
    },
    setDate(row) {
      row.T = row.T == 0 ? 0 : 1;
      if (row.StartDate > row.EndDate) {
        this.$message.warning("开始时间不能大于截止时间");
        row.EndDate = null;
      }
    },
    clearOpenId() {
      this.data.WxPublicId = "";
    },
    addJob() {
      this.data.Jobs.push({
        TeacherCheckId: 0,
        TeacherId: this.data.TeacherId,
        JobId: null,
        StartDate: null,
        EndDate: null,
        T: 0,
      });
    },
    delJob(row, index) {
      if (row.T != 0) this.DelJobs.push({ ...row, T: 2 });
      this.data.Jobs.splice(index, 1);
    },
    addCheck() {
      this.data.Checks.push({
        TeacherCheckId: 0,
        TeacherId: this.data.TeacherId,
        CheckYear: null,
        CheckResult: "",
        T: 0,
      });
    },
    delCheck(row, index) {
      if (row.T != 0) this.DelChecks.push({ ...row, T: 2 });
      this.data.Checks.splice(index, 1);
    },
    onIdCardBlur(e) {
      if (this.data.IdCard.length >= 14) {
        let date = this.$commonJs.toDateString(this.data.IdCard.substr(6, 8));
        if (date) {
          this.data.BirthDate = date;
          this.data.Age = new Date().getFullYear() - date.split("-")[0];
        }
      }
    },
    addDp() {
      this.data.Dps.push({
        DpEmpId: 0,
        DpId: null,
        DpName: "",
        TeacherId: this.data.TeacherId,
        TeacherName: this.data.TeacherName,
        IsMain: false,
        IsDirector: false,
        T: 0,
      });
    },
    delDp(row, index) {
      if (row.T != 0) this.DelDps.push({ ...row, T: 2 });
      this.data.Dps.splice(index, 1);
    },
    dpSelect(data, row) {
      console.log("???!!!",data,row)
      row.T = row.T == 0 ? 0 : 1;
      row.DpId = data.DpId;
      row.DpName = data.DpName;
    },
    dpChange(row) {
      var value = row.IsMain;
      this.data.Dps.forEach((x) => {
        x.IsMain = false;
        x.T = x.T == 0 ? 0 : 1;
      });
      row.IsMain = value;
    },
    addTag() {
      this.data.Tags.push({
        TagEmpId: 0,
        TagId: null,
        TagName: "",
        TeacherId: this.data.TeacherId,
        TeacherName: this.data.TeacherName,
        T: 0,
      });
    },
    delTag(row, index) {
      if (row.T != 0) this.DelTags.push({ ...row, T: 2 });
      this.data.Tags.splice(index, 1);
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        //年度考核情况
        var checkYear = this.data.Checks.every((x) => !!x.CheckYear);
        if (!checkYear) {
          this.$message.warning("年度考核情况 - 年度不能为空");
          return;
        }
        var checkResult = this.data.Checks.every((x) => !!x.CheckResult);
        if (!checkResult) {
          this.$message.warning("年度考核情况 - 考核结果不能为空");
          return;
        }

        //职务变动情况
        var jobId = this.data.Jobs.every((x) => !!x.JobId);
        if (!jobId) {
          this.$message.warning("职务变动情况 - 职务不能为空");
          return;
        }
        var startDate = this.data.Jobs.every((x) => !!x.StartDate);
        if (!startDate) {
          this.$message.warning("职务变动情况 - 开始时间不能为空");
          return;
        }
        // var endDate = this.data.Jobs.every((x) => !!x.EndDate);
        // if (!endDate) {
        //   this.$message.warning("职务变动情况 - 截止时间不能为空");
        //   return;
        // }

        var data = this.$commonJs.obj.removeNullKey(this.data);

        data.Jobs = this.data.Jobs.filter((x) => x.T != null);
        this.DelJobs.forEach((x) => data.Jobs.push(x));
        data.Jobs = data.Jobs.map((x) => {
          return this.$commonJs.obj.removeNullKey(x);
        });

        data.Checks = this.data.Checks.filter((x) => x.T != null);
        this.DelChecks.forEach((x) => data.Checks.push(x));
        data.Checks = data.Checks.map((x) => {
          return this.$commonJs.obj.removeNullKey(x);
        });

        data.Dps = this.data.Dps.filter((x) => x.T != null);
        this.DelDps.forEach((x) => data.Dps.push(x));
        data.Dps = data.Dps.map((x) => {
          return this.$commonJs.obj.removeNullKey(x);
        });

        data.Tags = this.data.Tags.filter((x) => x.T != null);
        this.DelTags.forEach((x) => data.Tags.push(x));
        data.Tags = data.Tags.map((x) => {
          return this.$commonJs.obj.removeNullKey(x);
        });

        console.log("api.save", data);
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.DelJobs = [];
      this.data.Jobs = [];
      this.DelChecks = [];
      this.data.Checks = [];
      this.DelDps = [];
      this.data.Dps = [];
    },
  },
};
</script>
<style lang="scss">
.no-per {
  line-height: 30px;
  text-align: center;
  width: 100%;
  display: inline-block;
}
</style>